import { render, staticRenderFns } from "./YearEndActivityCollect.vue?vue&type=template&id=15f6fd14"
import script from "./YearEndActivityCollect.vue?vue&type=script&lang=js"
export * from "./YearEndActivityCollect.vue?vue&type=script&lang=js"
import style0 from "./YearEndActivityCollect.vue?vue&type=style&index=0&id=15f6fd14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports